import type { IndicatorProps } from '@/components/Indicator/Indicator';
import i18n from '@/i18n';

const t = i18n.t.bind(i18n);

const MAAS_PHASE_STATUS_CONFIG: Record<string, { name: string; status: IndicatorProps['status'] }> = {
  Delete: { name: t('cluster:delete'), status: 'danger' },
  Running: { name: t('cluster:node-status-running'), status: 'success' },
  Failed: { name: t('cluster:failed'), status: 'danger' },
  ErrCreated: { name: t('cluster:failed'), status: 'danger' },
  ErrUpdated: { name: t('cluster:failed'), status: 'danger' },
  ErrDeleted: { name: t('cluster:failed'), status: 'danger' },
  ErrRestarted: { name: t('cluster:failed'), status: 'danger' },
  ErrStopped: { name: t('cluster:failed'), status: 'danger' },
  ErrStarted: { name: t('cluster:failed'), status: 'danger' },
  Success: { name: t('cluster:success'), status: 'success' },
  Pending: { name: t('cluster:pods-status-pending'), status: 'warning' },
  Restarting: { name: t('actions:restart.doing'), status: 'warning' },
  Restart: { name: t('actions:restart.doing'), status: 'warning' },
  Stopping: { name: t('cluster:stopping'), status: 'warning' },
  Terminating: { name: t('cluster:stopping'), status: 'warning' },
  Stop: { name: t('cluster:stopping'), status: 'warning' },
  Stopped: { name: t('cluster:stopped'), status: 'default' },
  Start: { name: t('cluster:starting'), status: 'warning' },
  Starting: { name: t('cluster:starting'), status: 'warning' },
  Update: { name: t('cluster:updating'), status: 'warning' },
  Paused: { name: t('cluster:stop'), status: 'default' },
  Provisioning: { name: t('cluster:provisioning'), status: 'warning' },
  ErrorUnschedulable: { name: t('cluster:error-unschedulable'), status: 'danger' },
  Unschedulable: { name: t('cluster:errorunschedulable'), status: 'danger' },
  CrashLoopBackOff: { name: t('data-center:crashloopbackoff'), status: 'danger' },
  Succeeded: { name: t('cluster:success'), status: 'success' },
  ErrorPvcNotFound: { name: t('common:error.pvc.not.found'), status: 'danger' },
  Reinstall: { name: t('common:reinstalling'), status: 'warning' },
  Completed: { name: t('cluster:completed'), status: 'success' },
  /** 计算集群实例等终态：已终止 */
  Terminated: { name: t('cluster:pods-status-terminated'), status: 'default' },
};

export function getMaasPhaseStatusItem(phase?: string): { name: string; status: IndicatorProps['status'] } {
  return (
    MAAS_PHASE_STATUS_CONFIG[phase ?? ''] ?? {
      name: phase || t('cluster:pending'),
      status: 'default',
    }
  );
}
